export default __webpack_public_path__ + "static/media/drag-and-drop-handler.a7238861.svg";